import { render } from "./farmingTask.vue?vue&type=template&id=05819de0&scoped=true&ts=true"
import script from "./farmingTask.vue?vue&type=script&lang=ts"
export * from "./farmingTask.vue?vue&type=script&lang=ts"

import "./farmingTask.vue?vue&type=style&index=0&id=05819de0&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05819de0"]])

export default __exports__